angular.module('hjApp.forms').component('passwordField', {
    bindings: {
        value: '=ngModel',
        isValid: '<?',
        companyName: '<?',
        label: '@?',
        placeholder: '@?',
        large: '<?',
        required: '<?'
    },
    controllerAs: 'ctrl',
    template: require('./password-field.component.html'),
    controller: function () {
        const ctrl = this;

        function mapStringToCharDistances(value) {
            const charCodes = value
                .toLowerCase()
                .split('')
                .map((c) => c.charCodeAt(0));
            const diffs = [];
            charCodes.forEach((c, index, arr) => {
                if (index <= arr.length - 2) {
                    diffs.push(Math.abs(arr[index + 1] - arr[index]));
                }
            });

            return diffs;
        }

        function validate(validators, value) {
            return validators.map((validator) => validator.validatorFn(value));
        }

        function allValid(validatorsState) {
            return validatorsState.every((state) => state);
        }

        function findLastMetCriterionIndex(passwordStrenghtCriteria, value) {
            const firstNotValid = passwordStrenghtCriteria
                .map((criterion) => allValid(validate(criterion.validators, value)))
                .indexOf(false);

            if (firstNotValid === -1) {
                return passwordStrenghtCriteria.length - 1;
            } else {
                return firstNotValid - 1;
            }
        }

        // It must be something that's different than a number
        const REPLACEMENT_TOKEN = 'x';

        const validators = [
            {
                validatorFn: (value) => value && value.length > 0
            },
            {
                caption: 'One lowercase character',
                validatorFn: (value) => value && /^(?=.*[a-z]).*$/.test(value)
            },
            {
                caption: 'One uppercase character',
                validatorFn: (value) => /^(?=.*[A-Z]).*$/.test(value)
            },
            {
                caption: '8 characters minimum',
                validatorFn: (value) => value && value.length >= 8
            },
            {
                // At least one number
                validatorFn: (value) => /^(?=.*\d).*$/.test(value)
            },
            {
                // No "Hotjar" or "HoTjAr" etc. in a string
                validatorFn: (value) => value.toLowerCase().lastIndexOf('hotjar') === -1
            },
            {
                // At least one special character
                validatorFn: (value) =>
                    new RegExp('^(?=.*[`@!%*?&=#~><{}";:,+\\^\\(\\)\\[\\]\\|\\\\/\\\'\\.\\$_\\-]).*$').test(value)
            },
            {
                // No value from an input in a password
                validatorFn: (value) =>
                    ctrl.companyName ? value.toLowerCase().lastIndexOf(ctrl.companyName.toLowerCase()) === -1 : true
            },
            {
                // No 3 same characters in a row 111, aaa, bbb
                validatorFn: (value) => !/(.)\1{2,}/i.test(value)
            },
            {
                // No 3 same characters in a sequence eg. 123, abcd
                // We map string to a char differences in array
                // Then we replace seleted distances (1 and 0 in this case) with a replacement token
                // This enables to reliably check if the characters sequence (substring) exists in the initial map
                // You can just check for "00" or "11" existence,
                // because arrays like [11,1,1] or [20,0,0] will break the check
                validatorFn: (value) =>
                    mapStringToCharDistances(value)
                        .map((d) => (d === 1 ? REPLACEMENT_TOKEN : d))
                        .join('')
                        .indexOf(`${REPLACEMENT_TOKEN}${REPLACEMENT_TOKEN}`) === -1
            },
            {
                validatorFn: (value) => (value ? value.length <= 64 : true),
                caption: 'Up to 64 characters long'
            }
        ];

        const requiredValidators = [validators[1], validators[2], validators[3]];

        const passwordStrenghtCriteria = [
            {
                caption: 'Weak',
                completedClass: 'weak',
                validators: [validators[0]]
            },
            {
                caption: 'Moderate',
                completedClass: 'moderate',
                validators: requiredValidators
            },
            {
                caption: 'Good',
                completedClass: 'good',
                validators: [validators[4], validators[5], validators[7], validators[8], validators[9]]
            },
            {
                caption: 'Excellent',
                completedClass: 'excellent',
                validators: [validators[6]]
            }
        ];

        ctrl.requiredValidators = requiredValidators;
        ctrl.passwordStrenghtCriteria = passwordStrenghtCriteria;
        ctrl.lastMetCriterionIndex = -1;
        ctrl.maxLenghtValidator = validators[10];

        ctrl.$onInit = function () {
            ctrl.label = ctrl.label || 'Password';
            ctrl.placeholder = ctrl.placeholer || 'Set a password...';
            ctrl.large = ctrl.large || false;
        };

        ctrl.updateValidationState = function (value, criteria, validators, additionalValidators = []) {
            if (ctrl.isValid && angular.isFunction(ctrl.isValid)) {
                ctrl.passwordValid = allValid(validate([...validators, ...additionalValidators], value));
                ctrl.isValid(ctrl.passwordValid);
            }

            ctrl.lastMetCriterionIndex = findLastMetCriterionIndex(criteria, value);
        };

        ctrl.isCriterionMet = function (criterionIndex, lastMetCriterionIndex) {
            return criterionIndex <= lastMetCriterionIndex;
        };

        ctrl.getStyle = function (criterionIndex, criteria) {
            if (criterionIndex <= ctrl.lastMetCriterionIndex) {
                return [criteria[ctrl.lastMetCriterionIndex].completedClass];
            } else {
                return [];
            }
        };

        ctrl.getCaption = function (index, criteria) {
            const criterion = criteria[index];
            if (criterion) {
                return criterion.caption;
            } else {
                return '';
            }
        };
    }
});
